import ApiService from "../../services/ApiService";

const MailingListService = {
    requestList: async (paginationModel, sort, setRows, setRowCount, keyword) => {
        let param = {
            page: paginationModel.page,
            pageSize: paginationModel.pageSize,
            sort: sort.map((s) => `${s.field}:${s.sort}`).join(","),
            keyword: keyword ? encodeURIComponent(keyword) : "",
        };

        const result = await ApiService.getData("/v1/mailing-list", param);
        setRows(result.content);
        setRowCount(result.page?.totalElements ?? 0);

        // Logger.log(result);
    },

    unsubscribe: async (id) => {
        const response = await ApiService.postData(`/v1/mailing-list/${id}/unsubscribe`, {});
        if (response && response.code === "FAILURE") {
            throw new Error(response.message || "Unsubscribe failed");
        }
        return response;
    },

    subscribe: async (id) => {
        const response = await ApiService.postData(`/v1/mailing-list/${id}/subscribe`, {});
        if (response && response.code === "FAILURE") {
            throw new Error(response.message || "Subscribe failed");
        }
        return response;
    },
};

export default MailingListService;
